import {
  cameraCaptureControl,
  cameraButton
} from './media-capture'

export const media = {
  cameraCaptureControl,
  cameraButton
}
